import en from "./en.js";
import zh from "./zh.js";
import vi from "./vi.js";
import ms from "./ms.js";

/**
 * The four languages this market needs, bundled rather than lazy-loaded.
 *
 * Bahasa Malaysia was the late addition and the most obvious omission: the site
 * is MYR, Malaysian banks and Malaysian bet limits, and it shipped without the
 * home market's own language. Comparable sites here carry it as a matter of
 * course.
 *
 * All four together are a few KB of strings — smaller than one of the game tiles
 * on the lobby. Splitting them would buy nothing and would cost a network round
 * trip on every language change, with untranslated text on screen while it
 * landed.
 *
 * The label is written IN its own language. A Vietnamese speaker looking for
 * their language scans for "Tiếng Việt", not for "Vietnamese" — a list of
 * endonyms is the one list everybody can read their own entry in.
 */
export const LOCALES = [
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "ms", label: "Bahasa Malaysia" },
];

export default { en, zh, vi, ms };
